import { render, staticRenderFns } from "./leavereportcontent.vue?vue&type=template&id=aafc372c"
import script from "./leavereportcontent.vue?vue&type=script&lang=js"
export * from "./leavereportcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports